<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="6" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">个人信息管理</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-camera"></i></div>
      <div class="gerenxinxi">个人信息管理</div>
    </div>
    <div class="head01">
      <Header :activeIndex="6" v-if="!isMobile" />
      <div class="head02">
        <div class="neirong">
          <div class="geren">个人信息管理
            <div class="xiangji2">
              <!-- <el-avatar :size="155" :src="avatarUrl"></el-avatar> -->
              <div :style="avatarStyle">{{ avatarInitial }}</div>
            </div>
          </div>
          <div style="display:flex;flex-direction: column;text-align: left;">
            <div class="jianju">
              <span class="span1">*姓名</span><el-input class="kuandu" v-model="xingming" placeholder="姓名"
                :disabled="isDisabled"></el-input>
            </div>
            <div class="jianju">
              <span class="span2">*性别</span><el-select v-model="xingbie" placeholder="请选择" class="kuandu"
                :disabled="isDisabled">
                <el-option v-for="item in xingbies" :key="item.xingbie" :label="item.label" :value="item.xingbie">
                </el-option>
              </el-select>
            </div>
            <div class="jianju">
              <span class="span1">*出生日期</span><el-date-picker v-model="birthday" type="date" placeholder="出生日期"
                format="yyyy-MM-dd" class="kuandu" value-format="yyyy-MM-dd" :disabled="isDisabled">
              </el-date-picker>
            </div>
            <div class="jianju">
              <span class="span2">民族</span><el-select v-model="minzu" filterable placeholder="请选择" :disabled="isDisabled"
                class="kuandu">
                <el-option v-for="item in minzus" :key="item.minzu" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </div>
            <div class="jianju">
              <span class="span2">兴趣爱好</span><el-input class="kuandu" v-model="aihao" placeholder="个人兴趣爱好"
                :disabled="isDisabled"></el-input>
            </div>
            <div class="jianju">
              <span class="span2">不良记录</span><el-input class="kuandu" v-model="buliangjilu" placeholder="不良记录"
                :disabled="isDisabled"></el-input>
            </div>
            <div class="jianju">
              <span class="span1">*联系电话</span><el-input class="kuandu" v-model="dianhua" placeholder="手机号"
                :disabled="isDisabled" @blur="validatePhone(dianhua)"></el-input>
              <div v-show="rightPhone" class="error">请输入正确的手机号</div>
            </div>
            <div class="jianju">
              <span class="span2">*联系邮箱</span><el-input class="kuandu" v-model="youxiang" placeholder="邮箱"
                :disabled="isDisabled" @blur="validateemail(youxiang)"></el-input>
              <div v-show="rightEmail" class="error">请输入正确的邮箱</div>
            </div>
            <div class="baocun" v-if="!isDisabled">
              <div class="save" @click="save">保存信息</div>
            </div>
          </div>
        </div>
        <div v-if="isDisabled" style="margin-top: 42px;" class="juzhong">
          <div class="qvxiao" @click="update">修改</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header.vue';
import Footer from './Footer.vue'
export default {
  name: 'personalInf',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      xingming: '',
      xingbie: '',
      birthday: '',
      xingbies: [{
        xingbie: '男',
        label: '男'
      }, {
        xingbie: '女',
        label: '女'
      }],
      minzus: [{
        minzu: '选项1',
        label: '汉族'
      }, {
        minzu: '选项2',
        label: '壮族'
      }, {
        minzu: '选项3',
        label: '满族'
      }, {
        minzu: '选项4',
        label: '回族'
      }, {
        minzu: '选项5',
        label: '苗族'
      }],
      minzu: '',
      value: '',
      dianhua: '',
      youxiang: '',
      aihao: '',
      buliangjilu: '',
      BASE_URL: 'https://zhiyedashi.com/info',
      // BASE_URL: 'http://192.168.2.8:8206',
      BASE_URL2: "https://zhiyedashi.com/career",
      avatarUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      userId: sessionStorage.getItem("userId"),
      isDisabled: false,
      id: null,
      rightPhone: false,
      rightEmail: false,
      avatarInitial: "",
      avatarStyle: {},
      isMobile: false,
      xueyexinxi: sessionStorage.getItem("xueyexinxi") === "true",
      zhiyeceshi: sessionStorage.getItem("zhiyeceshi") === "true",
    }
  },
  created() {
    if (!this.userId) {
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.selectUserInfo()
    this.minzuList()
    console.log(this.zhiyeceshi, this.xueyexinxi, !(this.zhiyeceshi && this.xueyexinxi));
    if (!(this.zhiyeceshi && this.xueyexinxi)) {
      this.scoreresult();
    }
  },
  methods: {
    scoreresult() {
      fetch(`${this.BASE_URL}/admin/score`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `userId=${this.userId}`,
      })
        .then((res) => res.json())
        .then((data) => {
          // console.log("学业成绩data", data);
          if (data.data === '暂无数据') {
            sessionStorage.setItem("xueyexinxi", "false")
          } else {
            sessionStorage.setItem("xueyexinxi", "true")
            this.careerresult()
          }
        })
        .catch((error) => {
          console.error("查询描述失败，原因是", error)
        });
    },
    careerresult() {
      fetch(`${this.BASE_URL2}/admin/career/result/selectUserId`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `userId=${this.userId}`,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.data === '暂无测试数据') {
            sessionStorage.setItem("zhiyeceshi", "false")
          } else {
            sessionStorage.setItem("zhiyeceshi", "true")
          }
        })
        .catch((error) => {
          console.error("查询失败，原因是", error)
        });
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    validatePhone(phone) {
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(phone)) {
        this.rightPhone = true
      } else {
        this.rightPhone = false
      }
    },
    validateemail(youxiang) {
      const emailRegex = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/;
      if (!emailRegex.test(youxiang)) {
        this.rightEmail = true
      } else {
        this.rightEmail = false
      }
      // console.log(this.rightEmail);
    },
    minzuList() {
      fetch(`${this.BASE_URL}/admin/ethnic`)
        .then(res => res.json())
        .then(data => {
          // console.log("data", data);
          this.minzus = data.data.map(item => ({
            label: item.nameZh,
            value: item.nameZh,
          }));
        })
        .catch(error => {
          console.error("查询民族报错，原因是", error);
        })
    },
    update() {
      this.isDisabled = false
    },
    selectUserInfo() {
      fetch(`${this.BASE_URL}/admin/user/info/selectUserInfo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `userId=${this.userId}`
      })
        .then(res => res.json())
        .then(data => {
          if (data.data === '用户信息为空') {
            this.isDisabled = false
          } else {
            let user = data.data
            this.id = user.id
            this.xingming = user.userName
            this.xingbie = user.gender
            this.birthday = user.birthday
            this.minzu = user.ethnicity
            this.aihao = user.hobbies || '无'
            this.buliangjilu = user.negativeRecord || '无'
            this.dianhua = user.phoneNumber
            this.youxiang = user.email
            if (this.xingming === '' || this.xingbie === '' || this.birthday === '' || this.dianhua === '') {
              this.isDisabled = false
            } else {
              this.isDisabled = true
            }
            this.touxiang()
          }
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    },
    touxiang() {
      this.avatarInitial = this.xingming.charAt(0);
      if (window.innerWidth <= 768) {
        // 移动端样式
        this.avatarStyle = {
          backgroundColor: this.xingbie === "女" ? "#FFB6C1" : "#4A90E2",
          color: "white",
          fontSize: "40px",
          textAlign: "center",
          lineHeight: "100px",
          borderRadius: "50%",
          width: "100px",
          height: "100px",
          marginTop: "10px"
        };
      } else {
        // 默认桌面端样式
        this.avatarStyle = {
          backgroundColor: this.xingbie === "女" ? "#FFB6C1" : "#4A90E2",
          color: "white",
          fontSize: "65px",
          textAlign: "center",
          lineHeight: "155px",
          borderRadius: "50%",
          marginTop: "15px"
        };
      }
    },
    save() {
      if (this.xingming === '' || this.xingbie === '' || this.birthday === '' || this.dianhua === '' || this.youxiang === '') {
        alert("姓名，性别，出生日期，联系电话，联系邮箱不可为空~")
      } else {
        if (this.rightPhone || this.rightEmail) {
          alert("请确保联系方式和邮箱格式正确~")
        } else {
          let userInfo = {
            id: this.id,
            userId: this.userId,
            avatarUrl: this.avatarUrl,
            userName: this.xingming,
            gender: this.xingbie,
            birthday: this.birthday,
            ethnicity: this.minzu,
            hobbies: this.aihao,
            negativeRecord: this.buliangjilu,
            phoneNumber: this.dianhua,
            email: this.youxiang
          }
          fetch(`${this.BASE_URL}/admin/user/info/saveUserInfo`, {
            method: 'post',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(userInfo)
          })
            .then(res => res.json())
            .then(data => {
              // console.log("保存成功", data);
              if (data.code === 200) {
                alert("个人信息保存成功")
                this.isDisabled = true
                this.selectUserInfo()
              } else {
                alert("网络有波动，请稍后重试")
              }
            })
            .catch(error => {
              console.error("保存失败，原因是", error);
            })
        }
      }
    }
  }
}
</script>

<style>
.el-input.is-disabled .el-input__inner {
  border: none !important;
  color: #000000 !important;
  font-size: 17px !important;
}

.el-textarea.is-disabled .el-textarea__inner {
  border: none !important;
  color: #000000 !important;
  font-size: 17px !important;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 300px !important;
}

.el-cascader-menu__wrap {
  height: 400px !important;
}

.el-avatar,
.el-cascader-panel,
.el-radio,
.el-radio--medium.is-bordered .el-radio__label,
.el-radio__label {
  font-size: 16px !important;
}
</style>

<style scoped>
.head01 {
  display: flex;
  gap: 130px;
}

.head02 {
  display: flex;
  gap: 130px;
}

.geren {
  font-size: 26px;
  text-align: left;
  font-weight: 700;
  margin-top: 20px;
}

.error {
  color: red;
  margin-left: 137px;
  font-size: 14px;
}

.kuandu {
  width: 300px;
}

.hengtiao1 {
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
}

.hengtiao {
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.xiangji2 {
  font-weight: 900;
  font-size: 155px;
  border: 1px soild #DCDFE6;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.neirong {
  display: flex;
  justify-content: center;
  /* align-items: center; */
  gap: 70px;
  margin-top: 30px;
  margin-left: 90px;
}

.jianju {
  margin-top: 15px;
}

.baocun {
  margin-top: 35px;
  display: flex;
  gap: 50px;
  margin-bottom: 50px;
  justify-content: center;
  align-items: center;
}

.span1 {
  margin-right: 7px;
  width: 130px;
  display: inline-block;
  text-align: right;
}

.span2 {
  margin-right: 7px;
  width: 100px;
  display: inline-block;
  margin-left: 30px;
  text-align: right;
}

.save {
  background-color: #3572e5;
  height: 40px;
  width: 200px;
  border-radius: 10px;
  color: white;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.qvxiao {
  border: 3px solid #bfc3ce;
  color: #2e323d;
  height: 40px;
  width: 200px;
  border-radius: 10px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

@media (max-width: 768px) {

  .hengtiao {
    height: 50px;
    width: 100%;
    background-color: #3572e5;
    color: white;
    display: flex;
    align-items: center;
  }

  .head01 {
    gap: 0px;
    flex-direction: column;
    width: 100%;
    padding-top: 140px;
  }

  .head02 {
    flex-direction: column;
    gap: 40px;
  }

  .neirong {
    margin-top: 10px;
    margin-left: 0;
    gap: 20px;
    flex-direction: column;
    align-items: center;
  }

  .geren {
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    margin-top: 0px;
  }

  .xiangji,
  .gerenxinxi {
    text-align: center;
  }

  .xiangji2 {
    font-size: 100px;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .kuandu {
    margin-left: 10px;
    width: 220px;
  }

  .span1,
  .span2 {
    margin-left: 10px;
    width: 75px;
    text-align: left;
  }

  .baocun {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .save {
    width: 220px;
    height: 50px;
    border-radius: 10px;
    margin-bottom: 20px;
  }

  .qvxiao {
    width: 220px;
    height: 50px;
    border-radius: 10px;
    margin-bottom: 20px;
    /* margin-top: 35px !important; */
  }

  .logo {
    width: 50px;
  }

  .juzhong {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0px !important;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 220px !important;
    margin-left: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userInfo.vue